@if(service.viewDroplistItems.length){
<div class='configuration-email-jobs-views-part'>
	@if(service.selectedViewItem(); as selectedViewItem){
	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem' (selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true' sortBy='customSort' style='display:inline-block'>
	</droplist>
	@switch (selectedViewItem.uniqueId) {
	@case (service.viewId.EmailJobs) {
	<configuration-email-jobs-view-part></configuration-email-jobs-view-part>
	}
	@case (service.viewId.EmailJobTriggers) {
	<configuration-email-job-triggers-view-part></configuration-email-job-triggers-view-part>
	}
	}
	}
</div>
}